import styled from 'styled-components';
import React, {ChangeEventHandler} from 'react';
import {Input} from 'components/Input';

const Wrapper = styled.section`
  background: #f5f5f5;
  padding: 14px 16px;
  font-size: 14px;
`

type Props = {
  value: string,
  onChange: (value: string) => void
}

const NoteSection: React.FC<Props> = (props) => {
  const note = props.value
  const onChange:ChangeEventHandler<HTMLInputElement> = (e) => {
    props.onChange(e.target.value)
  }

  return (
    <Wrapper>
      {/*
        ref是为了获取input，函数组件是不支持ref的
        受控组件，ref 和 defaultValue
        非受控组件，value onChange
      */}
      <Input type="text" label="备注" value={note} onChange={onChange}
             placeholder="请填写备注"/>
    </Wrapper>
  )
}

export {NoteSection};